import {BusinessCaseResponseBody} from '@dms/api/finance';

export const getSaleVehicleIdFromBusinessCase = (
  businessCase: BusinessCaseResponseBody | undefined
) => businessCase?.offers?.[0]?.saleVehicles?.[0]?.vehicleId ?? null;
